// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"ShippingRulesList_contentComponent__3JAUF","tableContainer":"ShippingRulesList_tableContainer__1rMry"};